
import { combineReducers } from 'redux';
import languageReducer from './LanguageList';
import cmsDatadetailsReducer from './CMSData';


const rootReducer = combineReducers({
  language: languageReducer, 
  cmsdatadetail : cmsDatadetailsReducer,
});

export default rootReducer;
